import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { messagingService } from '@/services/messaging'

export const useMessagesStore = defineStore('messages', () => {
  // State
  const unreadCount = ref(0)
  const conversations = ref([])
  const isLoading = ref(false)
  const lastUpdate = ref(null)

  // Computed
  const hasUnreadMessages = computed(() => unreadCount.value > 0)
  const totalUnreadCount = computed(() => {
    return conversations.value.reduce((total, conversation) => {
      return total + (conversation.unreadCount || 0)
    }, 0)
  })

  // Actions
  const fetchUnreadCount = async () => {
    if (!isLoading.value) {
      try {
        isLoading.value = true
        const count = await messagingService.getUnreadCount()
        unreadCount.value = count.unreadCount || 0
        lastUpdate.value = new Date()
      } catch (error) {
        console.error('Error fetching unread count:', error)
        // Don't throw error to avoid breaking the UI
      } finally {
        isLoading.value = false
      }
    }
  }

  const fetchConversations = async () => {
    if (!isLoading.value) {
      try {
        isLoading.value = true
        const data = await messagingService.getConversations()
        conversations.value = data
        // Update unread count from conversations
        unreadCount.value = totalUnreadCount.value
        lastUpdate.value = new Date()
      } catch (error) {
        console.error('Error fetching conversations:', error)
        // Don't throw error to avoid breaking the UI
      } finally {
        isLoading.value = false
      }
    }
  }

  const reset = () => {
    unreadCount.value = 0
    conversations.value = []
    lastUpdate.value = null
  }

  return {
    // State
    unreadCount,
    conversations,
    isLoading,
    lastUpdate,
    
    // Computed
    hasUnreadMessages,
    totalUnreadCount,
    
    // Actions
    fetchUnreadCount,
    fetchConversations,
    reset
  }
}) 